// Canonical auth store — re-export from src/ to avoid split-brain
export { useAuthStore } from "../src/stores/auth-store";
